export default __webpack_public_path__ + "static/media/Minahil Waqar.f7291308.jpeg";